import { Routes, Route, Navigate } from 'react-router-dom';
import type { Case } from '../../types';
import SubTabBar from '../../components/SubTabBar';
import UploadTab from '../../components/tabs/UploadTab';
import DocumentsTab from '../../components/tabs/DocumentsTab';
import ProductionTrackerTab from '../../components/tabs/ProductionTrackerTab';

interface Props {
  caseData: Case;
}

export default function DiscoverySection({ caseData }: Props) {
  const caseId = caseData.public_id;

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <SubTabBar
        basePath={`/cases/${caseData.public_id}/discovery`}
        tabs={[
          { to: 'upload', label: 'Upload Statements' },
          { to: 'documents', label: 'Documents' },
          { to: 'tracker', label: 'Production Tracker' },
        ]}
      />
      <div className="flex-1 overflow-y-auto [scrollbar-gutter:stable] p-6">
        <Routes>
          <Route path="upload" element={<UploadTab caseId={caseId} casePublicId={caseData.public_id} clientName={caseData.client_name} opposingPartyName={caseData.opposing_party_name} />} />
          <Route
            path="documents"
            element={
              <DocumentsTab
                caseId={caseData.public_id}
                clientName={caseData.client_name}
                opposingPartyName={caseData.opposing_party_name}
              />
            }
          />
          <Route
            path="tracker"
            element={
              <ProductionTrackerTab
                caseId={caseData.public_id}
                clientName={caseData.client_name}
                opposingPartyName={caseData.opposing_party_name}
              />
            }
          />
          {/* Accounts moved to Investigation — keep old links working. */}
          <Route path="accounts" element={<Navigate to={`/cases/${caseData.public_id}/investigation/accounts`} replace />} />
          {/* Absolute path — see InvestigationSection: relative `to` under a splat loops. */}
          <Route path="*" element={<Navigate to={`/cases/${caseData.public_id}/discovery/upload`} replace />} />
        </Routes>
      </div>
    </div>
  );
}
